import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ConsultationSection from './components/ConsultationSection';
import ExpertSection from './components/ExpertSection';
import CommunitySection from './components/CommunitySection';
import Footer from './components/Footer';
import SuccessPage from './pages/SuccessPage';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={
            <>
              <Navbar />
              <HeroSection />
              <ConsultationSection />
              <ExpertSection />
              <CommunitySection />
              <Footer />
            </>
          } />
          <Route path="/success" element={<SuccessPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;